import { createAction } from 'redux-act';
import {
    IAddCheckoutItem,
    IApplyDiscount,
    IInitiateRefund,
    IOpenCheckout,
    IProcessPayment,
    IRemoveCheckoutItem,
    ISetPaymentMethod,
    IUpdateCheckoutItemQuantity,
    IVerifyDiscount,
    types,
} from './types';

export const openCheckout = createAction<IOpenCheckout>(types.OPEN_CHECKOUT);
export const closeCheckout = createAction(types.CLOSE_CHECKOUT);
export const setCheckoutItems = createAction<IOpenCheckout>(types.SET_CHECKOUT_ITEMS);
export const addCheckoutItem = createAction<IAddCheckoutItem>(types.ADD_CHECKOUT_ITEM);
export const removeCheckoutItem = createAction<IRemoveCheckoutItem>(types.REMOVE_CHECKOUT_ITEM);
export const updateCheckoutItemQuantity = createAction<IUpdateCheckoutItemQuantity>(
    types.UPDATE_CHECKOUT_ITEM_QUANTITY,
);
export const applyDiscount = createAction<IApplyDiscount>(types.APPLY_DISCOUNT);
export const verifyDiscount = createAction<IVerifyDiscount>(types.VERIFY_DISCOUNT);
export const removeDiscount = createAction(types.REMOVE_DISCOUNT);
export const setPaymentMethod = createAction<ISetPaymentMethod>(types.SET_PAYMENT_METHOD);
export const processPayment = createAction<IProcessPayment>(types.PROCESS_PAYMENT);
export const processPaymentSuccess = createAction(types.PROCESS_PAYMENT_SUCCESS);
export const processPaymentFail = createAction<string>(types.PROCESS_PAYMENT_FAIL);
export const resetCheckout = createAction(types.RESET_CHECKOUT);
export const initiateRefund = createAction<IInitiateRefund>(types.INITIATE_REFUND);
export const initiateRefundSuccess = createAction<{ ticketId: string; state: 'refund-in-progress' | 'refunded' }>(
    types.INITIATE_REFUND_SUCCESS,
);
export const initiateRefundFail = createAction<string>(types.INITIATE_REFUND_FAIL);
